<template>
    <Container>
      <ConfirmModal v-if="marketForDeletion" item-type="Market" :item-name="marketForDeletion.name" :confirm="confirmDeleteMarket" :cancel="cancelDeleteMarket" />
      <FilteredItemList title="Markets" :fields="fields" :items="allMarkets" :on-click="goto" :search="true" @delete="askToDeleteMarket" :actions="{'Add Market': addNewMarket }" />
    </Container>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import ConfirmModal from "@/components/dialogs/ConfirmModal";
import {actionIf, delayedIfLoading} from "@/lib/Async";
import FilteredItemList from "@/components/ui/lists/FilteredItemList";
import Container from "@/components/ui/layout/Container";
import Icons from "@/lib/Icons";

export default {
  name: "Markets",
  components: {Container, FilteredItemList, ConfirmModal },
  data() {
    return {
      marketForDeletion: null,
      search : "",
      fields : [
        {label: "#", prop: "id", sortable: true, width: "60px" },
        {label: "Name", prop: "name", width: "20%", primary: true, sortable: true},
        {label: "Description", prop: "description", sortable: true},
        {label: "Actions", prop: "", width: "10%", actions: [
            { mood: "danger", icon: Icons.x, action: "delete", tooltip: "Delete" }
          ]}
      ]
    }
  },

  async mounted() {
    await delayedIfLoading(!this.isLoggedIn, actionIf([!this.allMarkets.length, this.getMarkets]), this.setLoading,
        () => this.isLoggedIn, () => this.$router.push('/'))
  },

  computed: {
    ...mapGetters(['isLoggedIn', 'allMarkets']),
  },

  methods: {
    ...mapActions(['getMarkets','setLoading','deleteMarket']),
    goto(market) {
      this.$router.push('/market/'+market.id)
    },
    addNewMarket() {
      this.$router.push('/market/new')
    },
    askToDeleteMarket(market) {
      this.marketForDeletion = market;
    },
    cancelDeleteMarket() { this.marketForDeletion = null },
    confirmDeleteMarket() {
      this.deleteMarket(this.marketForDeletion.id)
      this.marketForDeletion = null
    }
  },


}
</script>
